module.exports = __webpack_public_path__ + "img/orange_116.442f7684.png";